import { useState } from 'react';
import { isObjectEmpty } from '@/std/object';

export type Filter<T> = Partial<T> | undefined;

export function useFilter<T extends object>(
    initialFilter?: Filter<T>,
): {
    filter: Filter<T>;
    setFilter: (filter: Filter<T>) => void;
} {
    const [filter, setFilterState] = useState(initialFilter);

    const setFilter = (newFilter: Filter<T>): void => {
        setFilterState((oldFilter) => {
            const combinedFilter = { ...oldFilter, ...newFilter };

            if (isObjectEmpty(combinedFilter)) {
                return undefined;
            }

            return combinedFilter;
        });
    };

    return { filter, setFilter };
}
